import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

const StyledPlug = styled.div`
  opacity: 0;
  pointer-events: none;
`;

export const Plug: FC<PropsWithChildren> = (props) => (
  <StyledPlug className="voa_invisible_wrapper" {...props} />
) 